export enum TimeEnum {
  StartDayTime = '08:00',
  EndDayTime = '17:00',
  StartEveningTime = '17:00',
  EndEveningTime = '21:00',
}
